import { useMutation, useSuspenseQuery, useQueryClient } from '@tanstack/react-query';
import { addPublicICSSubscription, deletePublicICSSubscription, getPublicICSSubscription } from '@uplift/api';
import { BaseSuspenseQueryOpts } from './baseTypes';


export const usePublicICSSubscriptionQuery = (opts?: BaseSuspenseQueryOpts) => {
  return useSuspenseQuery({
    queryKey: [ 'public-ics-subscription' ],
    queryFn: () => getPublicICSSubscription(),
    select: res => res ? res.data : undefined,
    ...opts,
  });
};


export const useDeletePublicICSSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deletePublicICSSubscription,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [ 'public-ics-subscription' ] });
    }
  });
};


export const useAddPublicICSSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addPublicICSSubscription,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [ 'public-ics-subscription' ] });
    }
  });
};
